import { EyeNoneIcon, EyeOpenIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrel } from 'features/kestrelViewer'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVMeasurement } from 'types'

const MEASURE_VISIBLE_FIELD = 'measurementVisible'

const StyledEyeClosedIcon = styled(EyeNoneIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

const StyledEyeOpenIcon = styled(EyeOpenIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const ToggleMeasurementVisibilityButton: FC<{
  measurement: KVMeasurement
}> = ({ measurement }) => {
  const { updateMeasurement } = useKestrel()

  const toggleMeasurementVisibility = (e: React.MouseEvent) => {
    e.stopPropagation()
    const isVisible = measurement.visible
    if (updateMeasurement)
      updateMeasurement(
        measurement,
        MEASURE_VISIBLE_FIELD,
        (a: KVMeasurement) => {
          a.visible = !isVisible
          return a
        },
        !isVisible
      )
  }

  return (
    <TooltipWrapper
      label={measurement.visible ? 'Hide measurement' : 'Show measurement'}
      side='top'>
      <div
        style={{ cursor: 'pointer' }}
        onClick={(e) => toggleMeasurementVisibility(e)}>
        {measurement.visible ? (
          <StyledEyeOpenIcon width={22} height={22} />
        ) : (
          <StyledEyeClosedIcon width={22} height={22} />
        )}
      </div>
    </TooltipWrapper>
  )
}
